import {Component, Input} from '@angular/core';
import {Store} from "@ngrx/store";
import {FilesService} from "../../services/files/files.service";
import * as AuthSelectors from "../../state/auth/auth.selector";
import {User} from "../../auth/primitives/user";
import {NgIf} from "@angular/common";
import {selectUserById} from "../../state/users/users.selector";
import {DoWhenReadyService, Readyables} from "../../services/do-when-ready.service";
import {selectNetworkReady} from "../../state/network/network.selector";

@Component({
  selector: 'profile-image',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './profile-image.component.html',
  styleUrl: './profile-image.component.scss'
})
export class ProfileImageComponent {
  user: User = null
  profileBase64: string

  @Input()
  userId?: string

  constructor(
      private store: Store,
      private fileService: FilesService,
      private doWhenReady: DoWhenReadyService
  ) {
    this.doWhenReady.firstTime(this, [Readyables.network], (user) => {
      if (!this.userId) {
        this.store.select(AuthSelectors.selectUser).subscribe(async (user) => {
          this.user = user
          if (user) {
            const serverFile = await this.fileService.getFile(this.user.profile_image_file_id)
            this.profileBase64 = serverFile.fileData
          }
        })
      }
      if (this.userId) {
        this.store.select(selectUserById(this.userId)).subscribe(async (user) => {
          this.user = user
          if (user) {
            const serverFile = await this.fileService.getFile(this.user.profile_image_file_id)
            this.profileBase64 = serverFile.fileData
          }
        })
      }
    })
  }
}
